import { Fragment } from "react";

interface Step {
  id: string;
  label: string;
}

interface StepsBarProps {
  steps: Step[];
  currentStep: number;
  onStepChange: (step: number) => void;
}

const StepsBar = ({ steps, currentStep, onStepChange }: StepsBarProps) => {
  return (
    <div className="stepsBar">
      {steps.map((step, index) => {
        const stepIndex = index + 1;
        const className =
          stepIndex === currentStep
            ? "step active"
            : stepIndex < currentStep
              ? "step done"
              : "step";

        return (
          <Fragment key={step.id}>
            <div className={className} onClick={() => onStepChange(stepIndex)}>
              <span className="stepNum">
                {stepIndex < currentStep ? "✓" : stepIndex}
              </span>
              {step.label}
            </div>
            {stepIndex < steps.length ? (
              <span className="stepSep">›</span>
            ) : null}
          </Fragment>
        );
      })}
    </div>
  );
};

export default StepsBar;
